// extracted by mini-css-extract-plugin
export default {"searchbar":"Search_searchbar__FG5CP"};